<script setup>
  import { computed } from 'vue';

  import { useAlertStore } from "@/stores/AlertStore";

  import Icon from "@/components/icons/Icon.vue";

  const alertStore = useAlertStore();

  const alertTitle = computed(() => alertStore.alerts[0].event);
  const alertColor = computed(() => alertStore.alerts[0].color);
  const alertCount = computed(() => alertStore.alerts.length);
  const showAdditionalAlerts = computed(() => alertStore.hasAlerts && alertCount.value > 1);
  const additionalAlertCount = computed(() => showAdditionalAlerts.value ? alertCount.value - 1 : null);
</script>

<template>
  <a href="#advisories" class="jwx-alert-widget">
    <div :style="`--alert-color: #${alertColor}`" class="jwx-alert-widget__icon">
      <Icon name="advisories-filled" />
    </div>
    <div class="jwx-alert-widget__title">{{ alertTitle }}</div>
    <div v-if="showAdditionalAlerts" class="jwx-alert-widget__count">+{{ additionalAlertCount }}</div>
  </a>
</template>